








































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import {
  getCountry,
  getShippingLists
} from '@/api/prescription'
import { trackList, getDropdown, updateStatus } from '@/api/track/index'
import create from './components/create.vue'
import createOrder from './components/createOrder.vue'
import createTrack from './components/createTrack.vue'
import Pagination from '@/components/Pagination/index.vue'
import { AppModule } from '@/store/modules/app'
interface mySpan {
  row: Object
  column: Object
  rowIndex: number
  columnIndex: number
}
@Component({
  name: 'getorder',
  components: {
    Pagination,
    create,
    createOrder,
    createTrack
  }
})
export default class extends Vue {
  get lang() {
    return AppModule.language.toString()
  }

  private loading = false
  private form = {
    ship_type: '',
    country_id: '',
    code: '',
    customer_order_code: '',
    tsc_type: '',
    tsc_rules: '',
    tsc_status: '',
    create_date: []
  };

  public currentScope:any = {}
  public countryList:any = [];
  public shippingList:any = [];
  public multipleSelection:any = []
  private createVis = false
  private createVis2 = false
  private createVis3 = false

  private columns = [
    // { id: 'orders_code', label: '订单号' },
    { id: 'ae_code', label: 'AE单号' },
    { id: 'tracking_number', label: '跟踪号' },
    { id: 'customer_order_code', label: '客户参考号' },
    { id: 'ship_type', label: '运输方式' },
    { id: 'cn_name', label: '收件人国家/地区' },
    { id: 'tsc_type', label: '类型' },
    { id: 'tsc_rules_desc', label: '轨迹节点规则' },
    { id: 'tsc_status_desc', label: '状态' },
    { id: 'create_date', label: '操作时间' }
  ];

  // @Watch('lang', { immediate: true })
  // getlang(newone:any) {
  //   if (newone === 'en') {
  //     this.columns[0].label = 'Name of task'
  //     this.columns[1].label = 'Download time'
  //   } else {
  //     this.columns[0].label = '任务名称'
  //     this.columns[1].label = '创建时间'
  //   }
  // }

  private options = [];

  private dropdownList = []

  private pagObj = {
    total: 0,
    limit: 20,
    page: 1
  };

  private tdata = []

  handleSelectionChange(val:any) {
    this.multipleSelection = val
  }

  public getShippingLists() {
    const obj = {}
    getShippingLists(obj).then((res) => {
      this.shippingList = res.data
    })
  }

  public getCountry() {
    const obj = {}
    getCountry(obj).then((res) => {
      this.countryList = res.data
    })
  }

  private tscTypeList:any = []
  private tscRulesList:any = []
  private tscStatusList:any = []
  public handleGetDropdown() {
    getDropdown({
      type: ['tsc_type', 'tsc_rules', 'tsc_status']
    }).then((res) => {
      this.tscTypeList = Object.entries(res.data.tsc_type).map(([key, value]) => ({ key: Number(key), value }))
      this.tscRulesList = Object.entries(res.data.tsc_rules).map(([key, value]) => ({ key: Number(key), value }))
      this.tscStatusList = Object.entries(res.data.tsc_status).map(([key, value]) => ({ key: Number(key), value }))
    })
  }

  handleCreateClose() {
    this.createVis = false
    this.trackList()
  }

  handleCreateClose2() {
    this.createVis2 = false
    this.trackList()
  }

  handleCreateClose3() {
    this.createVis3 = false
    this.trackList()
  }

  handleCommand(val: any) {
    this.currentScope = null
    this.multipleSelection = []
    if (val === '1') {
      this.createVis = true
    } else if (val === '2') {
      this.createVis2 = true
    } else {
      this.createVis3 = true
    }
  }

  handleCommand2(val:any) {
    if (this.multipleSelection.length <= 1) {
      this.$message.error('请先选择多条数据')
      return
    }
    if (val === '1') {
      const flag = this.multipleSelection.some((item:any) => item.tsc_type === '1')
      if (flag) {
        this.$message.error('仅支持批量修改“指定订单”类型的轨迹规则')
        return
      }
      this.currentScope = null
      this.createVis2 = true
      // this.createVis = true
    } else {
      this.$confirm('确认删除后，已创建规则将即刻失效！', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        updateStatus({
          tsc_id: this.multipleSelection.map((item:any) => item.tsc_id).join(','),
          tsc_status: '2'
        }).then(() => {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.trackList()
        })
      })
    }
  }

  handleEdit(scope:any) {
    this.currentScope = scope.row
    if (scope.row.tsc_type === '1') {
      this.createVis = true
    } else if (scope.row.tsc_type === '2') {
      this.createVis2 = true
    } else if (scope.row.tsc_type === '3') {
      this.createVis3 = true
    }
  }

  handleDelete(scope:any) {
    this.$confirm('确认删除后，已创建规则将即刻失效！', '删除确认', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      updateStatus({
        tsc_id: scope.row.tsc_id,
        tsc_status: '2'
      }).then(() => {
        this.$message({
          message: '删除成功',
          type: 'success'
        })
        this.trackList()
      })
    })
  }

  handleRecover(scope:any) {
    updateStatus({
      tsc_id: scope.row.tsc_id,
      tsc_status: '1'
    }).then(() => {
      this.$message({
        message: '删除成功',
        type: 'success'
      })
      this.trackList()
    })
  }

  pagination(val: any) {
    console.log(val)
    this.$set(this.pagObj, 'page', val.page)
    this.$set(this.pagObj, 'limit', val.limit)
    this.$set(this.pagObj, 'total', 0)
    this.trackList()
  }

  created() {
    this.handleGetDropdown()
    this.getShippingLists()
    this.getCountry()
    this.trackList()
  }

  trackList() {
    this.loading = true
    const obj = Object.assign({ create_date_ge: '', create_date_le: '' }, { page: this.pagObj.page, page_size: this.pagObj.limit }, this.form)
    if (obj.create_date && obj.create_date.length > 0) {
      obj.create_date_ge = obj.create_date[0]
      obj.create_date_le = obj.create_date[1]
      // delete obj.create_date
    }
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading'
    })
    trackList(obj).then(res => {
      this.loading = false
      loading.close()
      if (res.code === '000000') {
        this.pagObj.total = +res.data.total
        this.tdata = res.data.list
      }
    })
  }

  searchRes() {
    this.pagObj.page = 1
    this.trackList()
  }

  clearall() {
    const dom:any = this.$refs.form
    dom.resetFields()
    this.pagObj.page = 1
    this.trackList()
  }

  canDownload(status:string, url:string) {
    if (status === '1') {
      window.open(url, '_blank')
    } else {
      this.$message.info('当前文件暂不可下载,稍后重试')
    }
  }
}
